<div fxHide fxShow.gt-sm *ngIf="order === refDatumOrder.column">
  <ul [formGroup]="form" [ngStyle]="{'height.px': ulHeight}">
    <li *ngFor="let item of refDatumItems">
      <iris-checkbox
        [formControlName]="item.id.toString()"
        [attr.data-test]="'list-checkbox-' + item.title"
      >
        {{ item.title }}
      </iris-checkbox>
    </li>
  </ul>
</div>

<div fxHide fxShow.gt-sm *ngIf="order === refDatumOrder.row">
  <mat-grid-list
    [cols]="columns"
    rowHeight="45px"
    class="marginBtm10"
    [formGroup]="form"
  >
    <mat-grid-tile *ngFor="let item of refDatumItems" colspan="1" rowspan="1">
      <div class="text-inside-grid">
        <iris-checkbox
          [formControlName]="item.id.toString()"
          [attr.data-test]="'grid-checkbox-' + item.title"
        >
          {{ item.title }}
        </iris-checkbox>
      </div>
    </mat-grid-tile>
  </mat-grid-list>
</div>

<div fxHide fxShow.lt-md>
  <form [formGroup]="form">
    <mat-selection-list (selectionChange)="onSelectionChange($event)">
      <mat-list-option togglePosition="before" *ngFor="let item of refDatumItems" [value]="item.id.toString()" [selected]="form.get(item.id.toString())?.value">
        <span matListItemTitle>{{ item.title }}</span>
      </mat-list-option>
    </mat-selection-list>
  </form>
</div>
